/* Siloueta — mouvements éditoriaux.
   Révélations lentes au scroll (images en rideau, titres mot à mot),
   en-tête qui s'affine au défilement. Aucune dépendance, désactivé si
   l'utilisatrice a demandé moins d'animations et dans l'éditeur de thème. */
(() => {
  const root = document.documentElement;
  root.classList.add('ed-js');

  // En-tête : état « défilé » (plus fin, filet discret).
  let ticking = false;
  const onScroll = () => {
    root.classList.toggle('ed-scrolled', window.scrollY > 24);
    ticking = false;
  };
  window.addEventListener('scroll', () => {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(onScroll);
    }
  }, { passive: true });
  onScroll();

  // Menu : la carte « L'Édit » du mega-menu rejoint la fin du tiroir mobile.
  const placeEdit = () => {
    const card = document.querySelector('[data-ed-mega-edit]');
    const panel = document.querySelector('.menu-drawer__submenu .menu-drawer__inner-submenu');
    if (!card || !panel) return false;
    if (panel.querySelector('[data-ed-mega-edit-mobile]')) return true;
    const copy = card.cloneNode(true);
    copy.removeAttribute('data-ed-mega-edit');
    copy.setAttribute('data-ed-mega-edit-mobile', '');
    copy.classList.add('ed-mega__edit--drawer');
    panel.appendChild(copy);
    return true;
  };
  placeEdit();
  window.addEventListener('load', placeEdit);
  // Le thème peut reconstruire l'en-tête : on repose la carte à chaque
  // ouverture du tiroir, sans rien faire si elle est déjà là.
  document.addEventListener('click', () => setTimeout(placeEdit, 80), true);

  // ---- Fiche produit : couleur choisie ----------------------------------
  // 1. Le libellé « Couleur » affiche la valeur sélectionnée.
  // 2. La galerie se regroupe sur le coloris choisi : ses photos passent
  //    devant, les autres suivent. Sans coloris dans le texte alternatif,
  //    rien ne bouge (aucun trou, aucune erreur).
  const colourStyle = () => {
    if (document.getElementById('ed-colour-style')) return;
    const tag = document.createElement('style');
    tag.id = 'ed-colour-style';
    tag.textContent =
      'legend[data-ed-picked]::after{content:" — " attr(data-ed-picked);color:var(--color-foreground);opacity:.85}';
    document.head.appendChild(tag);
  };

  const markColour = (scope = document) => {
    scope.querySelectorAll('legend, .variant-option__label').forEach((legend) => {
      const label = legend.textContent.trim().toLowerCase();
      if (!label.startsWith('couleur')) return;
      const group = legend.closest('fieldset, .variant-option');
      const picked = group?.querySelector('input:checked');
      if (!picked) return;
      colourStyle();
      const clean = legend.textContent.replace(/\s*—.*$/, '').trim();
      // On n'écrit que si nécessaire : sinon l'observateur repartirait en boucle.
      if (legend.textContent !== clean) legend.textContent = clean;
      if (legend.getAttribute('data-ed-picked') !== picked.value) {
        legend.setAttribute('data-ed-picked', picked.value);
      }
    });
  };

  const mediaColour = (el) => {
    const img = el.querySelector('img');
    const found = img && img.alt && img.alt.match(/coloris\s+(.+?)\s*$/i);
    return found ? found[1].trim().toLowerCase() : '';
  };

  const groupGallery = (gallery) => {
    const grid = gallery.querySelector('.media-gallery__grid');
    if (!grid) return;
    const reference = [...grid.children];
    if (reference.length < 3) return;
    const colour = mediaColour(reference[0]);
    if (!colour) return;

    const order = reference.map((el, index) => index);
    order.sort((a, b) => {
      const first = mediaColour(reference[a]) === colour ? 0 : 1;
      const second = mediaColour(reference[b]) === colour ? 0 : 1;
      return first - second || a - b;
    });
    if (order.every((value, index) => value === index)) return;

    const lists = [
      grid,
      gallery.querySelector('slideshow-slides'),
      gallery.querySelector('.dialog-zoomed-gallery'),
      gallery.querySelector('.dialog-thumbnails-list'),
    ].filter(Boolean);
    // Toutes les listes doivent être parallèles, sinon on ne touche à rien.
    if (lists.some((list) => list.children.length !== reference.length)) return;
    lists.forEach((list) => {
      const items = [...list.children];
      order.forEach((index) => list.appendChild(items[index]));
    });
  };

  const refreshProduct = () => {
    markColour();
    document.querySelectorAll('media-gallery').forEach(groupGallery);
  };
  refreshProduct();
  document.addEventListener('change', () => setTimeout(refreshProduct, 60), true);
  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches?.('media-gallery') || node.querySelector?.('media-gallery')) {
          refreshProduct();
          return;
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (!root.classList.contains('ed-motion') || !('IntersectionObserver' in window)) return;

  // Découpe un titre en mots, sans toucher aux balises (em, br…).
  const splitWords = (el) => {
    let i = 0;
    const walk = (node) => {
      [...node.childNodes].forEach((child) => {
        if (child.nodeType === Node.TEXT_NODE) {
          const frag = document.createDocumentFragment();
          child.textContent.split(/(\s+)/).forEach((part) => {
            if (!part) return;
            if (/^\s+$/.test(part)) {
              frag.appendChild(document.createTextNode(part));
              return;
            }
            const outer = document.createElement('span');
            const inner = document.createElement('span');
            outer.className = 'ed-w';
            inner.textContent = part;
            inner.style.setProperty('--w', i++);
            outer.appendChild(inner);
            frag.appendChild(outer);
          });
          child.replaceWith(frag);
        } else if (child.nodeType === Node.ELEMENT_NODE && child.tagName !== 'BR') {
          walk(child);
        }
      });
    };
    walk(el);
  };

  // Découpe le grand titre de couverture en lettres.
  const splitLetters = (el) => {
    const text = el.textContent.trim();
    el.textContent = '';
    [...text].forEach((ch, i) => {
      const span = document.createElement('span');
      span.className = 'ed-l';
      span.textContent = ch;
      span.style.setProperty('--l', i);
      el.appendChild(span);
    });
  };

  // Éléments en attente d'apparition. La détection passe par IntersectionObserver
  // et, en secours, par une vérification au défilement : aucun contenu ne peut
  // rester masqué, même si un navigateur ou un aperçu ne déclenche pas l'observateur.
  const pending = new Set();
  const reveal = (el) => {
    el.classList.add('is-in');
    pending.delete(el);
    if (observer) observer.unobserve(el);
  };
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting || entry.intersectionRatio > 0) reveal(entry.target);
    });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0 });

  const check = () => {
    const limit = window.innerHeight * 0.96;
    pending.forEach((el) => {
      const r = el.getBoundingClientRect();
      if (r.top < limit && r.bottom > 0) reveal(el);
    });
  };
  let checking = false;
  const scheduleCheck = () => {
    if (checking) return;
    checking = true;
    requestAnimationFrame(() => {
      checking = false;
      check();
    });
  };
  window.addEventListener('scroll', scheduleCheck, { passive: true });
  window.addEventListener('resize', scheduleCheck);
  window.addEventListener('load', check);
  document.addEventListener('visibilitychange', check);

  const init = (scope = document) => {
    scope.querySelectorAll('[data-ed-reveal]').forEach((el) => {
      if (el.dataset.edSeen) return;
      el.dataset.edSeen = '1';
      const kind = el.dataset.edReveal;
      if (kind === 'words') splitWords(el);
      if (kind === 'letters') splitLetters(el);
      // Léger décalage entre éléments voisins d'un même bloc.
      if (!el.style.getPropertyValue('--d')) {
        const siblings = [...el.parentElement.children].filter((c) => c.hasAttribute('data-ed-reveal'));
        el.style.setProperty('--d', Math.min(siblings.indexOf(el), 6));
      }
      pending.add(el);
      observer.observe(el);
    });
    // Après un premier affichage, pour que l'apparition soit bien animée.
    requestAnimationFrame(() => requestAnimationFrame(check));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  // Contenus chargés après coup (recommandations, filtres de collection…).
  new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType === 1 && (node.matches?.('[data-ed-reveal]') || node.querySelector?.('[data-ed-reveal]'))) {
          init(node.parentElement || document);
        }
      }
    }
  }).observe(document.body || root, { childList: true, subtree: true });

  // Retour arrière depuis le cache : tout est déjà visible.
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) document.querySelectorAll('[data-ed-reveal]').forEach((el) => el.classList.add('is-in'));
  });
})();
